import React from "react";

import DeleteResourceButton from "./DeleteResourceButton";
import { ResourceName } from "../descriptors";
import { useUserData } from "../context/UserDataProvider";
import { FormattedMessage } from "react-intl";

const DisabledDeleteResourceButton: React.FC<{
    resourceName: ResourceName; // resource type
    id: number; // the id of the resource to delete
    userId: number; // the user id this button belongs to - if current user, the button will be disabled
    translationKey: string;
}> = ({ resourceName, id, userId, translationKey }) => {
    const userData = useUserData();

    if (userData.userId == userId) {
        return (
            <DeleteResourceButton
                id={id}
                resourceName={resourceName}
                disabled={true}
                tooltip={<FormattedMessage id={translationKey} />}
            />
        );
    }

    return <DeleteResourceButton id={id} resourceName={resourceName} />;
};

export default DisabledDeleteResourceButton;
